import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
import { IasLoaderComponent } from "../../common/ias-loader/ias-loader.component";
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
declare var bootstrap: any;
@Component({
  selector: 'app-ias-signup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, IasLoaderComponent, ImageCropperComponent],
  templateUrl: './ias-signup.component.html',
  styleUrl: './ias-signup.component.scss',
  providers: [DatePipe]
})
export class IasSignupComponent implements OnInit, OnDestroy {

  currentStep = 1;
  emailForm: FormGroup;
  memberidForm: FormGroup;
  retiredForm: FormGroup;
  memberdetailsForm: FormGroup;
  isSso: boolean = false;
  token: string | null = null;
  sessionid: any = null;
  otpForm: FormGroup;
  passwordForm: FormGroup;
  otpControls = ['d1', 'd2', 'd3', 'd4', 'd5', 'd6'];
  countdown!: number;
  intervalId: any;
  isResendDisabled = false;
  showNewPassword = false;
  showConfirmPassword = false;
  passwordnotmatch = false;
  action: string = '';
  loading: boolean = false;
  email: string | null = null;
  mobilenumber: string | null = null;
  alternateemail: string | null = null;
  iasid: string | null = null;
  iasname: string | null = null;
  iasbatch: string | null = null;
  iascadre: string | null = null;
  iasprofilePic: string | null = null;
  toastMessage = '';
  toastType: string = 'primary';
  private myModal: any;
  imageChangedEvent: any = '';
  croppedImage: string | null = null; // live preview in Base64
  finalImage: string | null = null;   // locked cropped Base64 for API
  private modalInstance: any;
  contactType: 'email' | 'mobile' | null = null;
  cadrelist: any[] = []; // Example cadre list, replace with actual data
  maxDOB: string | undefined;
  constructor(private fb: FormBuilder, private http: HttpClient, private datePipe: DatePipe, private route: ActivatedRoute) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, this.contactValidator()]]
    });
    this.memberidForm = this.fb.group({
      name: ['', [Validators.pattern(/^[A-Za-z\s]+$/)]],
      identityNumber: ['', [Validators.required,]],
      mobilenumber: [''],
      email: [''],
      alternateEmail: [null, [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/)]],
    });
    this.retiredForm = this.fb.group({
      profilePic: ['', [Validators.required]],
      name: ['', [Validators.pattern(/^[A-Za-z\s]+$/)]],
      identityNumber: ['', [Validators.pattern(/^[0-9]{2}[A-Za-z]{2}[0-9]{6}$/),
      Validators.minLength(10),
      Validators.maxLength(10)]],
      dateofbirth: ['', [Validators.required]],
      cadre: [0, [Validators.required]],
      allotmentyear: ['', [Validators.required, Validators.pattern(/^[0-9]{4}$/)]],
      mobilenumber: [''],
      email: ['']
    });
    this.memberdetailsForm = this.fb.group({
      fullname: [''],
      cadre: [0, [Validators.required]],
      allotmentyear: ['', [Validators.required, Validators.pattern(/^[0-9]{4}$/)]],
      gender: ['', [Validators.required]],
      dateofbirth: ['', [Validators.required]],
      mothertongue: ['', [Validators.required]],
      retirementreason: ['', [Validators.required]],
      mobilenumber: [''],
      email: [''],
      alternateEmail: [null, [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/)]],
    });

    const controls: any = {};
    this.otpControls.forEach(ctrl => {
      controls[ctrl] = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]$/)]);
    });
    this.otpForm = this.fb.group(controls);

    this.passwordForm = this.fb.group({
      newPassword: ['', [
        Validators.required,
        Validators.minLength(6),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/)
      ]
      ],
      confirmPassword: ['', [Validators.required]]
    });
  }
  startCountdown(seconds: number) {
    this.countdown = seconds;
    this.isResendDisabled = true;

    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.isResendDisabled = false;
        clearInterval(this.intervalId);
      }
    }, 1000);
  }
  contactValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim();

      if (!value) return null;

      const emailRegex =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

      const mobileRegex =
        /^[6-9]\d{9}$/; // Indian 10-digit mobile

      if (emailRegex.test(value) || mobileRegex.test(value)) {
        return null;
      }

      return { invalidContact: true };
    };
  }
  updateContactValidators(form: FormGroup) {
    const mobileCtrl = form.get('mobilenumber');
    const emailCtrl = form.get('email');

    if (!mobileCtrl || !emailCtrl) return;

    // clear old validators
    mobileCtrl.clearValidators();
    emailCtrl.clearValidators();

    // apply based on contact type
    if (this.contactType === 'email') {
      mobileCtrl.setValidators([
        Validators.required,
        Validators.pattern(/^[6-9]\d{9}$/)
      ]);
    }

    if (this.contactType === 'mobile') {
      emailCtrl.setValidators([
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/)
      ]);
    }

    mobileCtrl.updateValueAndValidity();
    emailCtrl.updateValueAndValidity();
  }
assignContactValues(form: FormGroup) {
  const emailVal = form.get('email')?.value || null;
  const mobileVal = form.get('mobilenumber')?.value || null;

  if (this.contactType === 'mobile') {
    this.email = emailVal;
    this.mobilenumber = null;
  }

  if (this.contactType === 'email') {
    this.mobilenumber = mobileVal;
    this.email = null;
  }
}

  onResendOtp() {
    // 👉 call your API to resend OTP here

    this.startCountdown(59); // restart timer
  }

  signupWithGoogle() {
    window.location.href = `${environment.apiUrl}/accounts/google/login?intent=signup`;
  }

  ngOnInit() {
    const url = `${environment.apiUrl}/dopt/cadres?limit=0`;
    this.http.get(url).subscribe({
      next: (response: any) => {
        // console.log('cadeeeeessss', response);
        this.loading = false;
        this.cadrelist = response.data.data;
        // console.log('Cadre List:', this.cadrelist);
      },
    });
    const today = new Date();
    today.setFullYear(today.getFullYear() - 21); // subtract 21 years
    this.maxDOB = today.toISOString().split('T')[0]; // format: YYYY-MM-DD

    this.route.queryParams.subscribe(params => {
      if (params['sso'] && params['sessionToken']) {
        this.isSso = true;
        this.sessionid = params['sessionToken'];
        // Assume email for contact since Google SSO guarantees an email
        this.contactType = 'email'; 
        this.updateContactValidators(this.memberidForm);
        this.updateContactValidators(this.memberdetailsForm);
        this.updateContactValidators(this.retiredForm);
        this.currentStep = 3; 
      }
    });
  }
  // ngAfterViewInit(): void {
  //   const modalEl = document.getElementById('Warning');
  //   if (modalEl) {
  //     this.myModal = new bootstrap.Modal(modalEl, {
  //       backdrop: 'static',
  //       keyboard: false
  //     });
  //     this.myModal.show();
  //   }
  // }

  ngOnDestroy(): void {
    if (this.myModal) {
      this.myModal.hide();     // hide modal
      this.myModal.dispose();  // clean up bootstrap instance
      this.myModal = null;
    }
  }
  submitMemberId() {
    if (this.memberidForm.valid) {
      // console.log('Member ID submitted:', this.memberidForm.value);
      this.loading = true;
      const url = `${environment.apiUrl}/dopt/officers?limit=1&identityNo=` + this.memberidForm.value.identityNumber;
      this.http.get(url).subscribe({
        next: (response: any) => {
          // console.log('user details', response);
          this.iasid = response.data.data[0]?.id; // Store the token for later use
          this.iasname = response.data.data[0]?.englishName;
          this.iasbatch = response.data.data[0]?.allotmentYear;
          this.iascadre = response.data.data[0]?.cadreDomicile;
          this.iasprofilePic = response.data.data[0]?.profilePic;
          // console.log('IAS ID:', this.iasid);
          this.loading = false;
          if (this.iasid !== undefined && this.iasid !== null) {
            // console.log('Valid IAS ID found:', this.iasid);
            this.assignContactValues(this.memberidForm);
            this.alternateemail = this.memberidForm.value.alternateEmail || null;
            this.showToast('✅ Details Found Successfully', 'success');
            this.currentStep = 7;
          }
          else {
            this.loading = false;
            this.showToast('Details Not Found', 'danger');
          }
        },
        error: (err) => {
          this.loading = false;
          this.showToast('Error fetching IAS details', 'danger');
        }
      });
    }
  }
  openModal() {
    const modalEl = document.getElementById('uploadModal');
    if (modalEl) {
      this.modalInstance = new bootstrap.Modal(modalEl);
      this.modalInstance.show();
    }
  }

  onFileChange(event: any): void {
    this.imageChangedEvent = event;  // raw file change event
    this.croppedImage = null;
    this.finalImage = null;
  }

  // Convert Blob to Base64
  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  imageCropped(event: ImageCroppedEvent) {
    if (event.blob) {
      this.blobToBase64(event.blob)
        .then(base64 => this.croppedImage = base64)  // live preview in Base64
        .catch(err => console.error('Blob to Base64 conversion error:', err));
    }
  }

  // Lock the cropped Base64 image
  cropImage() {
    this.finalImage = this.croppedImage;
    this.retiredForm.patchValue({ profilePic: 'Uploaded' });
    this.modalInstance.hide();
  }

  submitRetired() {
    if (this.retiredForm.valid) {
      // console.log('Member ID submitted:', this.memberidForm.value);
       this.assignContactValues(this.retiredForm);
      this.loading = true;
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${this.sessionid}`,
        'Content-Type': 'application/json'
      });
      let payload = {
        profilePic: this.finalImage || null,
        name: this.retiredForm.value.name || null,
        ...(this.retiredForm.value.identityNumber != '' && { identityNo: this.retiredForm.value.identityNumber }),
        dob: this.retiredForm.value.dateofbirth || null,
        cadreId: +this.retiredForm.value.cadre || null,
        batch: String(this.retiredForm.value.allotmentyear) || null,
         ...(this.contactType === 'mobile'
    ? { email: this.email }
    : { mobileNo: String(this.mobilenumber) })
      }
      // console.log('Payload:', payload);
      const url = `${environment.apiUrl}/accounts/retired-member-signup`;
      this.http.post(url, payload, { headers }).subscribe({
        next: (response: any) => {
          // console.log('user details', response);
          this.iasid = response.data.user?.doptOfficer?.id; // Store the token for later use
          this.iasname = response.data.user?.name;
          this.iasbatch = response.data.user?.doptOfficer?.allotmentYear;
          this.iascadre = response.data.user?.doptOfficer?.cadre?.name;
          this.iasprofilePic = response.data.user?.doptOfficer?.profilePic || null;
          // console.log('IAS ID:', this.iasid);
         
          this.alternateemail = this.retiredForm.value.alternateEmail || null;
          this.loading = false;
          this.showToast('Form submitted successfully ✅', 'success');
          this.currentStep = 7;
        },
        error: (err) => {
          this.loading = false;
          this.showToast(err?.error?.message || 'Error submitting the form', 'danger');
        }
      });
    }
  }
  showToast(message: string, type: string = 'primary') {
    this.toastMessage = message;
    this.toastType = type;

    const toastEl = document.getElementById('liveToast');
    if (toastEl) {
      const toast = new bootstrap.Toast(toastEl, { delay: 3000 });
      toast.show();
    }
  }
  allow10Numbers(event: KeyboardEvent) {
    const charCode = event.key;

    // Allow only digits 0–9
    if (!/^[0-9]$/.test(charCode)) {
      event.preventDefault();
    }

    // Limit to 10 digits
    const input = event.target as HTMLInputElement;
    if (input.value.length >= 10) {
      event.preventDefault();
    }
  }

  allowOnlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow: a-z, A-Z, and space
    if (!/[a-zA-Z\s]/.test(event.key)) {
      event.preventDefault();
    }
  }
  validateYear(event: any) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Allow only 4 digits
    if (value.length > 4) {
      event.preventDefault();
      value = value.slice(0, 4);

      this.retiredForm.patchValue({ allotmentyear: value });
    }

    // Block future years
    const currentYear = new Date().getFullYear();
    if (+value > currentYear) {
      value = currentYear.toString();
    }

    input.value = value;
  }

  submitmemberdetails() {
    if (this.memberdetailsForm.valid) {
      // console.log('Member ID submitted:', this.memberdetailsForm.value);
      this.loading = true;
      // console.log('Date of Birth:', this.memberdetailsForm.value.dateofbirth);

      const formatted = this.datePipe.transform(this.memberdetailsForm.value.dateofbirth, 'dd/MM/yyyy');
      // console.log('Formatted Date of Birth:', formatted);
      const url = `${environment.apiUrl}/dopt/officers?limit=1&englishName=` + this.memberdetailsForm.value.fullname + '&populate=cadre' + '&cadre=' + this.memberdetailsForm.value.cadre + '&allotmentYear=' + this.memberdetailsForm.value.allotmentyear + '&gender=' + this.memberdetailsForm.value.gender + '&dob=' + formatted + '&mothertongue=' + this.memberdetailsForm.value.mothertongue + '&retirementreason=' + this.memberdetailsForm.value.retirementreason;
      this.http.get(url).subscribe({
        next: (response: any) => {
          // console.log('user details', response);
          this.iasid = response.data.data[0]?.id; // Store the token for later use
          this.iasname = response.data.data[0]?.englishName;
          this.iasbatch = response.data.data[0]?.allotmentYear;
          this.iascadre = response.data.data[0]?.cadreDomicile;
          this.iasprofilePic = response.data.data[0]?.profilePic;
          // console.log('IAS ID:', this.iasid);
          this.loading = false;
          if (this.iasid !== undefined && this.iasid !== null) {
            // console.log('Valid IAS ID found:', this.iasid);
            this.assignContactValues(this.memberdetailsForm);
            this.alternateemail = this.memberdetailsForm.value.alternateEmail || null;
            this.showToast('✅ Details Found Successfully', 'success');
            this.currentStep = 7;
          }
          else {
            this.loading = false;
            this.showToast('Details Not Found', 'danger');
          }
        },
        error: (err) => {
          this.loading = false;
          this.showToast('Error fetching IAS details', 'danger');
        }
      });
    }
  }
  submitdetails() {
    const url = `${environment.apiUrl}/accounts/details`;
    const payload = {
      identityNumber: {
        id: this.iasid
      },
       ...(this.contactType === 'mobile'
    ? { email: this.email }
    : { mobileNumber: String(this.mobilenumber) }),
      alternateEmail: this.alternateemail !== '' ? this.alternateemail : null,
    }
  
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.sessionid}`,
      'Content-Type': 'application/json'
    });
    this.http.post(url, payload, { headers }).subscribe({
      next: (response: any) => {
        // console.log('user details', response);
        // console.log('message', response.data.message);
        this.loading = false;
        this.showToast('✅ IAS Details submitted successful', 'success');
        if (this.isSso) {
          this.currentStep = 9;
        } else {
          this.currentStep = 8;
        }
      },
      error: (err) => {
        this.loading = false;
        this.showToast('Details already linked to another registered user', 'danger');
      }
    });
  }
  submitEmail() {
    if (!this.emailForm.valid) return;

    const value = this.emailForm.value.email.trim();

    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

    const mobileRegex =
      /^[6-9]\d{9}$/;

    // detect type (optional — for later use)
    if (emailRegex.test(value)) {
      this.contactType = 'email';
      this.updateContactValidators(this.memberidForm);
      this.updateContactValidators(this.memberdetailsForm);
      this.updateContactValidators(this.retiredForm);

    } else if (mobileRegex.test(value)) {
      this.contactType = 'mobile';
      this.updateContactValidators(this.memberidForm);
      this.updateContactValidators(this.memberdetailsForm);
      this.updateContactValidators(this.retiredForm);

    }
    this.loading = true;

    const url = `${environment.apiUrl}/accounts/signup`;

    // ✅ ALWAYS same payload key
    const payload = {
      email: value
    };

    this.http.post(url, payload).subscribe({
      next: (response: any) => {
        this.token = response.data.token;
        this.action = response.data.action;
        this.loading = false;

        this.showToast('✅ OTP sent successfully.', 'success');

        console.log('Detected type:', this.contactType);

        this.currentStep = 2;
        this.startCountdown(59);
      },
      error: () => {
        this.loading = false;
        this.showToast('Already registered.', 'danger');
      }
    });
  }

  onOtpInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    if (input.value && index < this.otpControls.length - 1) {
      const next = input.parentElement?.children[index + 1] as HTMLInputElement | undefined;
      next?.focus();
    }
  }
  handleKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    // ✅ allow navigation keys
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (allowedKeys.includes(event.key)) {
      // Handle backspace navigation
      if (event.key === 'Backspace' && !input.value && index > 0) {
        const prev = input.parentElement?.children[index - 1] as HTMLInputElement | undefined;
        prev?.focus();
      }
      return; // allow
    }

    // ✅ block non-digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }




  togglePassword(field: 'new' | 'confirm') {
    if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }
  submitOtp() {
    if (this.otpForm.valid) {
      this.loading = true;
      const otp = this.otpControls.map(ctrl => this.otpForm.get(ctrl)?.value).join('');
      // console.log('OTP entered:', otp);
      const url = `${environment.apiUrl}/accounts/otpverify`;
      const token = this.token;
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      });
      const payload = {
        otp: otp,
        action: this.action, // Use the action stored from the signup response
        token: this.token // Include the token in the payload
      }
      // console.log('otp payload', payload);

      this.http.patch(url, payload, { headers }).subscribe({
        next: (response: any) => {
          // console.log('otp verified ', response);
          this.sessionid = response.data.sessionToken; // Store the session ID for later use
          this.loading = false;
          this.showToast('✅ OTP verified successfully', 'success');
          this.currentStep = 3; // ✅ move to password step
        },
        error: (err) => {
          this.loading = false;
          this.showToast('Failed to verify OTP', 'danger');
        }
      });
    }
  }

  submitPassword() {
    if (this.passwordForm.valid) {
      if (this.passwordForm.value.newPassword !== this.passwordForm.value.confirmPassword) {
        this.passwordnotmatch = true;
        return;
      }
      // console.log('Password created:', this.passwordForm.value);
      const formdata = this.passwordForm.value;
      const url = `${environment.apiUrl}/accounts/setup-password`;
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${this.sessionid}`,
        'Content-Type': 'application/json'
      });
      const payload = {
        password: formdata.newPassword,
        confirmPassword: formdata.confirmPassword
      }
      // console.log('payload', payload);
      this.http.post(url, payload, { headers }).subscribe({
        next: (response: any) => {
          // console.log('Signup successful:', response);
          this.showToast('✅ Password setup successfully', 'success');
          this.currentStep = 9;
        },
        error: (err) => {
          this.loading = false;
          this.showToast('Failed to set Password', 'danger');
        }
      });

    }
  }
}
